class ProductBuyBox extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('[data-buy-box-variant-input]')?.closest('form');
    this.variantInput = this.querySelector('[data-buy-box-variant-input]');
    this.options = Array.from(this.querySelectorAll('[data-buy-box-option]'));
    this.submitBtn = this.querySelector('[data-buy-box-submit]');
    this.submitText = this.querySelector('[data-buy-box-submit-text]');

    this.addToCartLabel = this.submitText ? this.submitText.textContent : 'Add to cart';
    this.unavailableLabel = 'Unavailable';
    this.addedLabel = 'Added!';

    this.options.forEach((option) => {
      const radio = option.querySelector('[data-buy-box-radio]');
      if (!radio) return;

      radio.addEventListener('change', () => {
        this.options.forEach((o) => o.classList.remove('is-selected'));
        option.classList.add('is-selected');
        this.selectVariant(option);
      });

      if (radio.checked) {
        this.selectVariant(option);
      }
    });

    if (this.form) {
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.addToCart();
      });
    }
  }

  selectVariant(option) {
    const variantId = option.getAttribute('data-variant-id');
    const available = option.getAttribute('data-available') === 'true';

    if (this.variantInput) {
      this.variantInput.value = variantId;
    }

    if (this.submitBtn) {
      this.submitBtn.disabled = !available;
    }

    if (this.submitText) {
      this.submitText.textContent = available ? this.addToCartLabel : this.unavailableLabel;
    }
  }

  addToCart() {
    if (!this.form || !this.submitBtn || this.submitBtn.disabled) return;

    const formData = new FormData(this.form);
    this.submitBtn.disabled = true;
    const previousLabel = this.submitText ? this.submitText.textContent : '';

    fetch('/cart/add.js', {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json' }
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status) {
          // Shopify returns an error object with a "status" key on failure
          throw new Error(data.description || 'Unable to add to cart');
        }

        if (this.submitText) {
          this.submitText.textContent = this.addedLabel;
        }

        document.dispatchEvent(
          new CustomEvent('buy-box:added-to-cart', { bubbles: true, detail: data })
        );

        setTimeout(() => {
          if (this.submitText) this.submitText.textContent = previousLabel;
          this.submitBtn.disabled = false;
        }, 1800);
      })
      .catch(() => {
        if (this.submitText) this.submitText.textContent = previousLabel;
        this.submitBtn.disabled = false;
      });
  }
}

customElements.define('product-buy-box', ProductBuyBox);
